<template>
  <drawer
    v-model="drawer"
    title="Filters"
    destroy-on-close
    @closed="$emit('close')">
    <div class="mnb-field">
      <label>Date Range</label>
      <div :class="{ error: dateRangeLimitError, 'flex-between': true }">
        <date-time-picker
          v-model="form.fromDate"
          value-type="String"
          value-format="yyyy-LL-dd"
          format="yyyy-LL-dd"
          :time-picker="false"
          :auto-close="true"
          min-date="2020-01-01"
          :max-date="today" />
        <span>To</span>
        <date-time-picker
          v-model="form.toDate"
          value-type="String"
          value-format="yyyy-LL-dd"
          format="yyyy-LL-dd"
          class="position-bottom-right"
          :time-picker="false"
          :auto-close="true"
          min-date="2020-01-01"
          :max-date="today" />
      </div>
      <div v-if="dateRangeLimitError" class="error-message">Maximum date range is 60 days</div>
    </div>

    <div class="mnb-field">
      <label>Account Type</label>
      <select v-model="form.accountType" :disabled="!form.toDate && !form.fromDate" class="mnb-input">
        <option></option>
        <option value="Business">Business</option>
        <option value="Personal">Personal</option>
      </select>
    </div>

    <div class="mnb-field">
      <label>Account</label>
      <input class="mnb-input" type="text" v-model="form.account"/>
    </div>

    <div class="mnb-field">
      <label>Profile</label>
      <input class="mnb-input" type="text" v-model="form.profileNumber"/>
    </div>

    <div class="mnb-field">
      <label>Profile Name</label>
      <input class="mnb-input" type="text" v-model="form.profileName"/>
    </div>

    <div class="mnb-field">
      <label>Statement Number</label>
      <input class="mnb-input" type="text" v-model="form.number"/>
    </div>

    <template #footer>
      <button
        class="button secondary mr-5"
        @click="$emit('close')">
        Cancel
      </button>
      <button
        class="button main"
        type="primary"
        @click="filter()">
        Filter
      </button>
    </template>
  </drawer>
</template>

<script>
import Drawer from '../../../components/Drawer'
import DateTimePicker from 'vue-vanilla-datetime-picker'

export default {
  props: {
    filters: {
      type: Object,
      default: null
    }
  },

  components: {
    Drawer,
    DateTimePicker
  },

  data () {
    return {
      form: {
        fromDate: null,
        toDate: null,
        account: null,
        accountType: null,
        profileNumber: null,
        profileName: null,
        number: null
      },

      today: moment("00:00:00", "HH:mm:ss").format("YYYY-MM-DD"),
      drawer: true
    }
  },

  computed: {
    dateRangeLimitError () {
      if (this.form.fromDate && this.form.toDate) {
        const from = moment(this.form.fromDate, 'YYYY-MM-DD')
        const to = moment(this.form.toDate, 'YYYY-MM-DD')
        if (to.diff(from, 'days') > 60) {
          return true
        }
      }
      return false
    }
  },

  created () {
    if (this.filters) {
      this.form = JSON.parse(JSON.stringify(this.filters))
    }
  },

  methods: {
    filter () {
      if (this.dateRangeLimitError) return

      this.$emit('apply', this.form)
    }
  }
}
</script>

<style lang="scss" scoped>
  .error-message {
    margin-top: 5px;
  }
</style>
